import loc from 'owa-localize';
import { hoverTooltipWithoutDuplication as strings_hoverTooltipWithoutDuplication } from './getHoverTooltip.locstring.json';

import type { LocalizedString, ResourceId } from 'owa-localize';

export function getHoverTooltip(
    controlName: ResourceId,
    description: ResourceId | undefined,
    hotkey?: string
): LocalizedString {
    let tooltip = description ? loc(description) : loc(controlName);

    if (hotkey) {
        tooltip = loc(strings_hoverTooltipWithoutDuplication, tooltip, hotkey);
    }

    return tooltip;
}
